import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import API from "../services/api";
import "./OrderDetails.css";

function OrderDetails() {

    const { id } = useParams();
    const [order, setOrder] = useState(null);

    useEffect(() => {

        let interval;

        const fetchOrder = async () => {
            try { 
                const res = await API.get(`/api/order/${id}`);
                setOrder(res.data);

                if (res.data.orderStatus === "DELIVERED") {
                    clearInterval(interval);
                }

            } catch (error) {
                console.log(error);
            }
        };

        fetchOrder();

        interval = setInterval(fetchOrder, 5000);

        return () => clearInterval(interval);

    }, [id]);


    const cancelOrder = async () => {
        try {
            await API.put(`/api/order/cancel/${id}`);
            window.location.reload();
        } catch (error) {
            console.log(error);
        }
    };

    const getStep = (status) => {
        switch (status) {
            case "PENDING": return 1;
            case "SHIPPED": return 2;
            case "DELIVERED": return 3;
            default: return 0;
        }
    };

    if (!order) return <h4>Loading...</h4>;

    const step = getStep(order.orderStatus);

    return (
        <div className="od-page">

            <div className="od-container">

                <div className="od-header">
                    <div>
                        <h2>Order #{order.id}</h2>
                        <p className="date">
                            {new Date(order.orderDate).toLocaleString()}
                        </p>
                    </div>

                    <p style={{ fontSize: "12px", color: "gray" }}>
                        Auto-updating...
                    </p>

                    <span className={`status ${order.orderStatus}`}>
                        {order.orderStatus}
                    </span>
                </div>

                {order.orderStatus === "CANCELLED" && (
                    <div className="cancelled">❌ Order Cancelled</div>
                )}

                {order.orderStatus !== "CANCELLED" && (
                    <div className="od-tracking">

                        <div className={`step ${step >= 1 ? "done" : ""}`}>
                            <span>📦</span>
                            <p>Order Placed</p>
                        </div>

                        <div className={`step ${step >= 2 ? "done" : ""}`}>
                            <span>🚚</span>
                            <p>Shipped</p>
                        </div>

                        <div className={`step ${step >= 3 ? "done" : ""}`}>
                            <span>🏠</span>
                            <p>Delivered</p>
                        </div>

                    </div>
                )}

                <div className="od-items">
                    {order.items.map(item => (
                        <div key={item.productId} className="od-item">

                            <img
                                src={item.imageUrl || "/default.png"}
                                alt={item.productName}
                            />

                            <div className="od-info">
                                <h4>{item.productName}</h4>
                                <p>Qty: {item.quantity}</p>
                                <p className="price">₹ {item.price}</p>
                            </div>

                        </div>
                    ))}
                </div>

                <div className="od-bottom">

                    <div className="od-address">
                        <h5>Delivery Address</h5>
                        <p>{order.address.fullName}</p>
                        <p>{order.address.street}</p>
                        <p>{order.address.city}, {order.address.state}</p>
                        <p>{order.address.pincode}</p>
                    </div>

                    <div className="od-payment">
                        <h5>Payment</h5>
                        <p><strong>{order.paymentMethod}</strong></p>
                        <p className="pay-status">{order.paymentStatus}</p>
                        <h4>Total: ₹ {order.totalPrice}</h4>
                    </div>

                </div>

                {order.orderStatus === "PENDING" && (
                    <button className="cancel-btn" onClick={cancelOrder}>
                        Cancel Order
                    </button>
                )}

            </div>

        </div>
    );
}

export default OrderDetails;